// EmptyState — "no data" placeholder per COMPONENTS §Catalog.
//
// The `empty` arm of the 5-state contract. Caller supplies the (already-i18n'd)
// title + optional description, an optional decorative icon, and an optional
// primary action — which the CALLER permission-gates (a permission-less user
// gets the copy without the CTA, per COMPONENTS §States). EmptyState renders
// only variables, so no user-facing string lives in this file.

import type { ReactNode } from 'react';

export interface EmptyStateProps {
  /** Decorative illustration / icon — wrapped aria-hidden. */
  icon?: ReactNode;
  title: string;
  description?: string;
  /** Primary action (e.g. a permission-gated <Button>). */
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className = '' }: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center px-6 py-12 text-center ${className}`}>
      {icon && (
        <div aria-hidden className="mb-3 text-[var(--color-text-secondary)]">
          {icon}
        </div>
      )}
      <p className="text-base font-semibold text-[var(--color-text-primary)]">{title}</p>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-[var(--color-text-secondary)]">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
